import React from "react";

import { Route, RouteProps } from "react-router-dom";

// Source
import * as HelperSrc from "../../HelperSrc";
import ControllerRoute from "../../controller/Route";
import ViewPageAccessDenied from "../PageAccessDenied";
import ViewPageInvoiceList from "./PageInvoiceList";
import ViewPageInvoiceProfile from "./PageInvoiceProfile";
import ViewPageInvoiceUpload from "./PageInvoiceUpload";
import ViewPageInvoiceUploadList from "./PageInvoiceUploadList";
import ViewPageClientList from "./PageClientList";
import ViewPageClientProfile from "./PageClientProfile";
import ViewPageClientContactList from "./PageClientContactList";
import ViewPageClientContactProfile from "./PageClientContactProfile";
import ViewPagePayerList from "./PagePayerList";
import ViewPagePayerProfile from "./PagePayerProfile";
import ViewPagePayeeList from "./PagePayeeList";
import ViewPagePayeeProfile from "./PagePayeeProfile";
import ViewPagePaymentPiList from "./PagePaymentPiList";
import ViewPagePaymentProfile from "./PagePaymentProfile";
import ViewPagePaymentFrList from "./PagePaymentFrList";
import ViewPagePaymentPdList from "./PagePaymentPdList";
import ViewPageUserClientMapList from "./PageUserClientMapList";
import ViewPageUserClientMapProfile from "./PageUserClientMapProfile";
import ViewPageTeamList from "./PageTeamList";
import ViewPageTeamProfile from "./PageTeamProfile";
import ViewPageTaskList from "./PageTaskList";
import ViewPageTaskProfile from "./PageTaskProfile";
import ViewPageTaskCalendar from "./PageTaskCalendar";

const viewRoute: React.FC = () => {
    // Variable
    const controllerRoute = new ControllerRoute();

    const [getIsRendered, setIsRendered] = React.useState(false);

    // Method
    controllerRoute.initializeHook();

    React.useEffect(() => {
        const init = async () => {
            await controllerRoute.checkRedirect();

            setIsRendered(true);
        };

        init();
    }, []);

    // Render
    if (getIsRendered && controllerRoute.getStorageMain && !controllerRoute.getApiLoadingList.myProfile) {
        if (controllerRoute.getStorageMain) {
            if (controllerRoute.getUserData) {
                HelperSrc.checkSessionTimeout(controllerRoute.getStorageMain, controllerRoute.getStorageSetting, controllerRoute.getUserData);

                return (
                    <>
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.task_profile.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.task_profile.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPageTaskProfile {...props} userData={controllerRoute.getUserData} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.task_list.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.task_list.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPageTaskList {...props} userData={controllerRoute.getUserData} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.task_calendar.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.task_calendar.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPageTaskCalendar {...props} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.invoice_upload.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.invoice_upload.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPageInvoiceUpload {...props} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.invoice_upload_list.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.invoice_upload_list.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPageInvoiceUploadList {...props} userData={controllerRoute.getUserData} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.invoice_profile.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.invoice_profile.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPageInvoiceProfile {...props} userData={controllerRoute.getUserData} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.invoice_list.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.invoice_list.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPageInvoiceList {...props} userData={controllerRoute.getUserData} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.client_profile.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.client_profile.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPageClientProfile {...props} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.client_list.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.client_list.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPageClientList {...props} userData={controllerRoute.getUserData} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.client_contact_profile.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.client_contact_profile.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPageClientContactProfile {...props} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.client_contact_list.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.client_contact_list.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPageClientContactList {...props} userData={controllerRoute.getUserData} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.payer_profile.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.payer_profile.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPagePayerProfile {...props} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.payer_list.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.payer_list.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPagePayerList {...props} userData={controllerRoute.getUserData} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.payee_profile.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.payee_profile.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPagePayeeProfile {...props} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.payee_list.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.payee_list.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPagePayeeList {...props} userData={controllerRoute.getUserData} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.payment_pi_list.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.payment_pi_list.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPagePaymentPiList {...props} userData={controllerRoute.getUserData} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.payment_profile.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.payment_profile.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPagePaymentProfile {...props} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.payment_fr_list.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.payment_fr_list.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPagePaymentFrList {...props} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.payment_pd_list.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.payment_pd_list.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPagePaymentPdList {...props} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.team_profile.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.team_profile.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPageTeamProfile {...props} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.team_list.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.team_list.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPageTeamList {...props} userData={controllerRoute.getUserData} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.user_client_map_list.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.user_client_map_list.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPageUserClientMapList {...props} userData={controllerRoute.getUserData} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.user_client_map_profile.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.user_client_map_profile.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPageUserClientMapProfile {...props} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                    </>
                );
            } else {
                return <></>;
            }
        } else {
            return <></>;
        }
    } else {
        return <></>;
    }
};

export default viewRoute;
